import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { MobileTopBar } from "./MobileTopBar";
import { useIsMobile } from "@/shared/hooks/use-mobile";
import { BugReportButton } from "@/features/bug-reports";

interface AppLayoutProps {
    children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <div className="flex flex-col h-[100dvh] bg-background">
                <MobileTopBar />
                <main className="flex-1 overflow-auto min-h-0">
                    {children}
                </main>
                <BugReportButton />
            </div>
        );
    }

    return (
        <div className="flex h-screen bg-background overflow-hidden">
            <Sidebar
                collapsed={sidebarCollapsed}
                onCollapsedChange={setSidebarCollapsed}
            />
            <main className="min-h-0 flex-1 overflow-auto">
                {children}
            </main>
            <BugReportButton />
        </div>
    );
}
